/**
 * Order Context
 *
 * Manages shopping cart and delivery settings state.
 * TODO: Move this to a separate 'orders' feature when scaling
 */

import { createContext } from "react";
// Import from components/types for compatibility with vendor-dashboard components
import { Product } from "@semo/shared-product";
import type { OrderItem, DeliverySettings } from "../../../types";

export interface OrderContextType {
  // Order items
  orderItems: OrderItem[];
  addToOrder: (product: Product) => void;
  updateOrderItem: (id: string, updates: Partial<OrderItem>) => void;
  removeFromOrder: (id: string) => void;
}

export const OrderContext = createContext<OrderContextType | undefined>(
  undefined,
);
OrderContext.displayName = "OrderContext";
